import {
  Button,
  Card,
  Flex,
  Heading,
  PlusIcon,
  Text,
} from '@buffer-mono/popcorn'

import styles from './GenerateApiKeyCard.module.css'

import type { JSX } from 'react'

interface GenerateApiKeyCardProps {
  description?: string
  onGenerate: () => void
}

export function GenerateApiKeyCard({
  description,
  onGenerate,
}: GenerateApiKeyCardProps): JSX.Element {
  return (
    <Card className={styles.card}>
      <Flex direction="column" gap="md">
        <Flex direction="column" gap="2xs">
          <Heading as="h3" size="xsmall">
            Create a Personal Key
          </Heading>

          <Text color="subtle">
            {description ??
              'Use keys to access your own Buffer data to build automations & integrations.'}
          </Text>
        </Flex>

        <Button variant="primary" size="large" onClick={onGenerate}>
          <PlusIcon />
          New Key
        </Button>
      </Flex>
    </Card>
  )
}
